"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisplayContainer = exports.DisplayCanvas = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.function.bind");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _palette = require("@artsy/palette");

var _Fonts = require("../../../../Assets/Fonts");

var _react = _interopRequireDefault(require("react"));

var _reactTracking = _interopRequireDefault(require("react-tracking"));

var _reactWaypoint = _interopRequireDefault(require("react-waypoint"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ErrorBoundary = require("../../../ErrorBoundary");

var _Helpers = require("../../../Helpers");

var _Constants = require("../../Constants");

var _ExternalTrackers = require("../ExternalTrackers");

var _trackOnce = require("../track-once");

var _CanvasContainer = require("./CanvasContainer");

var _dec, _dec2, _dec3, _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin: 35px 0 10px 0;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin: 15px 0 0 0;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: fit-content;\n  max-width: ", "\n  margin: 0 auto;\n  box-sizing: border-box;\n  a {\n    text-decoration: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

var DisplayCanvas = (_dec = (0, _reactTracking.default)(), _dec2 = (0, _trackOnce.trackImpression)(function (props) {
  return (0, _CanvasContainer.unitLayout)(props);
}), _dec3 = (0, _trackOnce.trackViewability)(function (props) {
  return (0, _CanvasContainer.unitLayout)(props);
}), _dec(_class = (_class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DisplayCanvas, _React$Component);

  function DisplayCanvas(props) {
    var _this;

    _classCallCheck(this, DisplayCanvas);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DisplayCanvas).call(this, props));
    _this.trackViewability = _this.trackViewability.bind(_assertThisInitialized(_this));
    _this.trackImpression = _this.trackImpression.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DisplayCanvas, [{
    key: "trackImpression",
    value: function trackImpression() {// noop
    }
  }, {
    key: "trackViewability",
    value: function trackViewability() {// noop
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          unit = _this$props.unit,
          campaign = _this$props.campaign,
          article = _this$props.article,
          renderTime = _this$props.renderTime;
      var url = unit.link ? (0, _get2.default)(unit, "link.url", "") : "";

      var disclaimer = _react.default.createElement(Disclaimer, {
        layout: unit.layout
      }, unit.disclaimer);

      return _react.default.createElement(_ErrorBoundary.ErrorBoundary, null, _react.default.createElement(DisplayContainer, {
        layout: unit.layout
      }, _react.default.createElement(_reactWaypoint.default, {
        onEnter: this.trackImpression
      }), _react.default.createElement(_reactWaypoint.default, {
        bottomOffset: "50%",
        onEnter: this.trackViewability
      }), _react.default.createElement("a", {
        href: (0, _ExternalTrackers.replaceWithCacheBuster)(url, (0, _Constants.getCurrentUnixTimestamp)()),
        target: "_blank"
      }, _react.default.createElement(SponsoredBy, null, "Sponsored by ".concat(campaign.name))), _react.default.createElement(_CanvasContainer.CanvasContainer, {
        unit: unit,
        campaign: campaign,
        article: article,
        disclaimer: disclaimer
      }), unit.layout === "overlay" && disclaimer, _react.default.createElement(_ExternalTrackers.PixelTracker, {
        unit: unit,
        date: renderTime
      })));
    }
  }]);

  return DisplayCanvas;
}(_react.default.Component), (_applyDecoratedDescriptor(_class2.prototype, "trackImpression", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "trackImpression"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "trackViewability", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "trackViewability"), _class2.prototype)), _class2)) || _class);
exports.DisplayCanvas = DisplayCanvas;
var Div = _styledComponents.default.div;
var DisplayContainer = Div(_templateObject(), function (props) {
  return props.layout === "slideshow" ? "100%;" : "1250px;";
});
exports.DisplayContainer = DisplayContainer;

var SponsoredBy = _styledComponents.default.div.withConfig({
  displayName: "Canvas__SponsoredBy",
  componentId: "v4wc1d-0"
})(["", ";color:", ";margin:10px 0;text-align:center;"], (0, _Fonts.avantgarde)("s11"), (0, _palette.color)("black30"));

var Disclaimer = Div(_templateObject2(), (0, _Fonts.garamond)("s11"), (0, _palette.color)("black30"), function (props) {
  return props.layout === "overlay" && "text-align: center;";
}, _Helpers.pMedia.sm(_templateObject3()));
//# sourceMappingURL=index.js.map